import { moneyFormat } from '../../../../../services/util';
import { downloadXlsx } from '../../../../../services/util/excel';

export default (calculadoraRE, isAdministrativo) => {
  const titulos = [
    'Administrativo',
    'Remuneração Total',
    'Remuneração Base',
    'Salário',
    'Transporte',
    'Refeição',
    'Alimentação',
    'Cesta de Benefícios',
    'Ajuda de Custo',
    'Valor Adicional',
    'Prêmio',
    'PI/DA',
    'Dependentes',
    'Líquido Salário',
    'Líquido Complementar',
    'PAT',
    'Total Líquido',
    'INSS',
    'IRRF',
    'Assistencia Médica',
    'Desconto Complementar',
    'Custo Total',
    'Odontológica',
    'Outros Custos',
    'Alimentação / Refeição',
    'FGTS',
    '% GPS / INSS',
    'GPS / INSS',
    'Provisão 13 Salário',
    'Encargos 13 Salário',
    'Férias + 1/3',
    'Encargos Férias + 1/3',
    '40% do FGTS - Rescisão',
    'Total de Encargos',
  ];

  const valores = [
    isAdministrativo ? 'Sim' : 'Não',
    moneyFormat(calculadoraRE.getRemuneracaoTotal()),
    moneyFormat(calculadoraRE.getRemuneracaoBase()),
    moneyFormat(calculadoraRE.getSalario()),
    moneyFormat(calculadoraRE.getTransporte()),
    moneyFormat(calculadoraRE.getRefeicao()),
    moneyFormat(calculadoraRE.getAlimentacao()),
    moneyFormat(calculadoraRE.getBeneficios()),
    moneyFormat(calculadoraRE.getAjudaCusto()),
    moneyFormat(calculadoraRE.getValorAdicional()),
    moneyFormat(calculadoraRE.getPremio()),
    moneyFormat(calculadoraRE.getPida()),
    calculadoraRE.getDependentes(),
    moneyFormat(calculadoraRE.getSalarioLiquido()),
    moneyFormat(calculadoraRE.getLiquidoComplementar()),
    moneyFormat(calculadoraRE.getPat()),
    moneyFormat(calculadoraRE.getTotalLiquido()),
    moneyFormat(calculadoraRE.getInss()),
    moneyFormat(calculadoraRE.getIrrf()),
    moneyFormat(calculadoraRE.getAssistenciaMedica()),
    moneyFormat(calculadoraRE.getIrrfComplementar()),
    moneyFormat(calculadoraRE.getCustoTotal()),
    moneyFormat(calculadoraRE.getOdontologico()),
    moneyFormat(calculadoraRE.getOutrosCustos()),
    moneyFormat(calculadoraRE.getAlimentacaoRefeicao()),
    moneyFormat(calculadoraRE.getFgts()),
    calculadoraRE.getPercentualGps()
      ? `${calculadoraRE.getPercentualGps().toFixed(2)} %`
      : '',
    moneyFormat(calculadoraRE.getGpsInss()),
    moneyFormat(calculadoraRE.getProvisaoDecimoTerceiro()),
    moneyFormat(calculadoraRE.getEncargosDecimoTerceiro()),
    moneyFormat(calculadoraRE.getFeriasUmTerco()),
    moneyFormat(calculadoraRE.getEncargosFeriasUmTerco()),
    moneyFormat(calculadoraRE.getFgtsRescisao()),
    moneyFormat(calculadoraRE.getTotalEncargos()),
  ];
  const linhas = [titulos, valores];
  downloadXlsx(
    'Remuneração',
    linhas,
    `remuneracao_total_${new Date().toLocaleString()}`
  );
};
